let browseSvg = 
  `
    <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `
  
  let giveSvg = 
  `
  <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `

  let down_caret = 
  `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><polygon points="50 77.1 2.15 28.51 7.85 22.9 50 65.7 92.15 22.9 97.85 28.51 50 77.1"></polygon></g></svg>
  `

  //FAQ下拉菜单
  let menuFaqList = [
    {
      categoryId:'Headphones',
      categoryName: 'ヘッドフォン',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'Xシリーズ',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Over Ear シリーズ',
          productList:[
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            {
              productId: 'TOZO_H10',
              productName: 'TOZO H10',
            },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Open シリーズ',
          productList:[
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_OpenEarRing',
              productName: 'TOZO OpenEarRing',
            }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'T シリーズ',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Tonal シリーズ',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_T6S',
              productName: 'TOZO T6S',
            },
            {
              productId: 'TOZO_T10S',
              productName: 'TOZO T10S',
            },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'NC シリーズ',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            {
              productId: 'TOZO_NC9_Plus',
              productName: 'TOZO NC9 Plus',
            },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: ' TOZO_Cryatl_Pods',
              productName: ' TOZO Cryatl Pods',
            },
          ]
        },
        {
          seriesId: 'NC_Pro_Series',
          seriesName: 'NC Pro シリーズ',
          productList:[
            {
              productId: 'TOZO_NC2_Pro',
              productName: 'TOZO NC2 Pro',
            },
            {
              productId: 'TOZO_NC7_Pro',
              productName: 'TOZO NC7 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro',
              productName: 'TOZO NC9 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro_Max',
              productName: 'TOZO NC9 Pro Max',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
          ]
        },
        {
          seriesId: 'A_Series',
          seriesName: 'A シリーズ',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'Agile_Series',
          seriesName: 'Agile シリーズ',
          productList:[
            {
              productId: 'TOZO_Agile_Pods',
              productName: 'TOZO Agile Pods',
            },
            {
              productId: 'TOZO_Agile_Dots',
              productName: 'TOZO Agile Dots',
            },
          ]
        },
        {
          seriesId: 'E_Series',
          seriesName: 'E シリーズ',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
        {
          seriesId: 'G_Series',
          seriesName: 'G シリーズ',
          productList:[
            {
              productId: 'TOZO_G1',
              productName: 'TOZO G1',
            },
            {
              productId: 'TOZO_Gaming_Pods',
              productName: 'TOZO Gaming Pods',
            },
          ]
        },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: '腕時計',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: '腕時計',
          productList:[
            {
              productId: 'TOZO_S1',
              productName: 'TOZO S1',
            },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            {
              productId: 'TOZO_S3',
              productName: 'TOZO S3',
            },
            {
              productId: 'TOZO_S4',
              productName: 'TOZO S4',
            },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'スピーカー',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'スピーカー',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'パノラマカメラ',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'スマートオーディオとビデオ',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'ワイヤレス充電',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'ワイヤレス充電器',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            {
              productId: 'TOZO_WB1',
              productName: 'TOZO WB1',
            },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            {
              productId: 'TOZO_W8',
              productName: 'TOZO W8',
            },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
        //   ]
        // }
      ]
    },
    {
      categoryId: 'Charger',
      categoryName: '充電器',
      seriesList:[
        {
          seriesId: 'Wall_Chargers',
          seriesName: '壁掛け充電器',
          productList:[
            {
              productId: 'TOZO_C1',
              productName: 'TOZO C1',
            },
            {
              productId: 'TOZO_C2',
              productName: 'TOZO C2',
            },
          ]
        },
        {
          seriesId: 'Power_Banks',
          seriesName: 'パワーバンク',
          productList:[
            {
              productId: 'TOZO_PB1',
              productName: 'TOZO PB1',
            },
            {
              productId: 'TOZO_PB2',
              productName: 'TOZO PB2',
            },
            {
              productId: 'TOZO_PB3',
              productName: 'TOZO PB3',
            },
          ]
        },
      ]
    },
  ]

  //Manuals下拉菜单
  let menuManualsList = [
    {
      categoryId:'Headphones',
      categoryName: 'ヘッドフォン',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'Xシリーズ',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
            {
              productId: 'TOZO_Color_Pods',
              productName: 'TOZO Color Pods',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Over Ear シリーズ',
          productList:[
            {
              productId: 'TOZO_HA1',
              productName: 'TOZO HA1',
            },
            {
              productId: 'TOZO_HT1',
              productName: 'TOZO HT1',
            },
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            // {
            //   productId: 'TOZO_H10',
            //   productName: 'TOZO H10',
            // },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Open シリーズ',
          productList:[
            {
              productId: 'TOZO_Open_X2_Pro',
              productName: 'TOZO Open X2 Pro',
            },
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_Open_EarRing',
              productName: 'TOZO Open EarRing',
            },
            {
              productId: 'TOZO_O2',
              productName: 'TOZO O2',
            },
            // {
            //   productId: 'TOZO_OpenWear',
            //   productName: 'TOZO OpenWear',
            // }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'Tシリーズ',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Tonal シリーズ',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_Tonal_Fits',
              productName: 'TOZO Tonal Fits',
            },
            // {
            //   productId: 'TOZO_T6S',
            //   productName: 'TOZO T6S',
            // },
            // {
            //   productId: 'TOZO_T10S',
            //   productName: 'TOZO T10S',
            // },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'NC シリーズ',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            // {
            //   productId: 'TOZO_NC9_Plus',
            //   productName: 'TOZO NC9 Plus',
            // },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
            {
              productId: 'TOZO_Crystal_Pods',
              productName: 'TOZO Crystal Pods',
            },
          ]
        },
        // {
        //   seriesId: 'NC_Pro_Series',
        //   seriesName: 'NC Pro シリーズ',
        //   productList:[
        //     {
        //       productId: 'TOZO_NC2_Pro',
        //       productName: 'TOZO NC2 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC7_Pro',
        //       productName: 'TOZO NC7 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro',
        //       productName: 'TOZO NC9 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro_Max',
        //       productName: 'TOZO NC9 Pro Max',
        //     },
        //   ]
        // },
        {
          seriesId: 'A_Series',
          seriesName: 'A シリーズ',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        // {
        //   seriesId: 'Agile_Series',
        //   seriesName: 'Agile シリーズ',
        //   productList:[
        //     {
        //       productId: 'TOZO_Agile_Pods',
        //       productName: 'TOZO Agile Pods',
        //     },
        //     {
        //       productId: 'TOZO_Agile_Dots',
        //       productName: 'TOZO Agile Dots',
        //     },
        //   ]
        // },
        // {
        //   seriesId: 'G_Series',
        //   seriesName: 'G シリーズ',
        //   productList:[
        //     {
        //       productId: 'TOZO_G1',
        //       productName: 'TOZO G1',
        //     },
        //     {
        //       productId: 'TOZO_Gaming_Pods',
        //       productName: 'TOZO Gaming Pods',
        //     },
        //   ]
        // },
        {
          seriesId: 'E_Series',
          seriesName: 'E シリーズ',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: '腕時計',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: '腕時計',
          productList:[
            {
              productId: 'TOZO_S1',
              productName: 'TOZO S1',
            },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            {
              productId: 'TOZO_S3',
              productName: 'TOZO S3',
            },
            {
              productId: 'TOZO_S4',
              productName: 'TOZO S4',
            },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'スピーカー',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'スピーカー',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'パノラマカメラ',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'スマートオーディオとビデオ',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'ワイヤレス充電',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'ワイヤレス充電器',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            {
              productId: 'TOZO_WB1',
              productName: 'TOZO WB1',
            },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            {
              productId: 'TOZO_W8',
              productName: 'TOZO W8',
            },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
        //   ]
        // }
      ]
    },
    {
      categoryId: 'Charger',
      categoryName: '充電器',
      seriesList:[
        {
          seriesId: 'Wall_Chargers',
          seriesName: '壁掛け充電器',
          productList:[
            {
              productId: 'TOZO_C1',
              productName: 'TOZO C1',
            },
            {
              productId: 'TOZO_C2',
              productName: 'TOZO C2',
            },
          ]
        },
        {
          seriesId: 'Power_Banks',
          seriesName: 'パワーバンク',
          productList:[
            {
              productId: 'TOZO_PB1',
              productName: 'TOZO PB1',
            },
            {
              productId: 'TOZO_PB2',
              productName: 'TOZO PB2',
            },
            {
              productId: 'TOZO_PB3',
              productName: 'TOZO PB3',
            },
          ]
        },
      ]
    },
  ]


  //FAQ资源
  let faqList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //故障资源
  let TrobuleshootingList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //视频资源
  let videoHttps = 'https://s3-us-tozo-production.tozostore.com/support/video/'
  let language = 'EN'
  let VideoTutoralList = [
    //X系列
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    //H系列
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    {
      id:3,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      title: 'TOZO H10',
      url: `${videoHttps}H10_${language}.mp4`,
    },
    //Open系列
    {
      id:4,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title: 'TOZO OpenBuds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    //T系列
    {
      id:7,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_T6S',
      productName: 'TOZO T6S',
      title: 'TOZO T6S',
      url: `${videoHttps}T6S_${language}.mov`,
    },
    {
      id:9,
      productId: 'TOZO_T10S',
      productName: 'TOZO T10S',
      title: 'TOZO T10S',
      url: `${videoHttps}T10S_${language}.mp4`,
    },
    {
      id:10,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title: 'TOZO Crystal Buds',
      url: `${videoHttps}T18_${language}.mp4`,
    },
    {
      id:11,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title: 'TOZO T20',
      url: `${videoHttps}T20_${language}.mp4`,
    },
    //Tonal系列
    {
      id:12,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title: 'TOZO Tonal Fits',
      url: `${videoHttps}Tonal_Fits_${language}.mp4`,
    },
    {
      id:13,
      productId: 'TOZO_Tonal_Pots',
      productName: 'TOZO Tonal Pods',
      title: 'TOZO Tonal Pods',
      url: `${videoHttps}Tonal_Pods_${language}.mp4`,
    },
    //A系列
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:15,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title: 'TOZO A3',
      url: `${videoHttps}A3_${language}.mp4`,
    },
    //Agile系列
    {
      id:16,
      productId: 'TOZO_Agile_Dots',
      productName: 'TOZO Agile Dots',
      title: 'TOZO Agile Dots',
      url: `${videoHttps}Agile_Dots_${language}.mov`,
    },
    {
      id:17,
      productId: 'TOZO_Agile_Pods',
      productName: 'TOZO Agile Pods',
      title: 'TOZO Agile Pods',
      url: `${videoHttps}Agile_Pods_${language}.mov`,
    },
    //NC系列
    {
      id:18,
      productId: 'TOZO_NC7_Pro',
      productName: 'TOZO NC7 Pro',
      title: 'TOZO NC7 Pro',
      url: `${videoHttps}NC7_Pro${language}.mp4`,
    },
    {
      id:19,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9',
      url: `${videoHttps}NC9_${language}.mp4`,
    },
    {
      id:20,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9',
      url: `${videoHttps}NC9_2_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC9_Pro',
      productName: 'TOZO NC9 Pro',
      title: 'TOZO NC9 Pro',
      url: `${videoHttps}NC9_Pro_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title: 'TOZO NC20 Pro',
      url: `${videoHttps}NC20_Pro_${language}.mp4`,
    },

    //S系列 手表
    {
      id:22,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
    {
      id:23,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'TOZO S6 スマートウォッチの開梱ビデオ',
      url: `${videoHttps}S6_${language}.mp4`,
    },
    {
      id:24,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'TOZO S6 ウォッチバンドの取り付けビデオガイド',
      url: `${videoHttps}S6_watch_band_installation_video_guide_${language}.mp4`,
    },

    //P系列 音箱
    {
      id:25,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title: 'TOZO PA1',
      url: `${videoHttps}PA1_${language}.mp4`,
    },

    //Panoramic Camera系列 相机
    {
      id:26,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue クイック共有チュートリアル',
      url: `${videoHttps}AnyVue_quick_sharing_tutorial_${language}.mp4`,
    },
    {
      id:27,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue 教育ビデオ AI ディクテーション修正 2',
      url: `${videoHttps}AnyVue_teaching_video_AI_dictation_modification_2_${language}.mp4`,
    },
    {
      id:28,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue リンク VinsionPro 操作',
      url: `${videoHttps}AnyVue_link_VinsionPro_operation_${language}.mp4`,
    },
    {
      id:29,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue YouTube ライブ ブロードキャスト enAI ディクテーション修正',
      url: `${videoHttps}AnyVue_YouTube_live_broadcast_enAI_dictation_modification_${language}.mp4`,
    },
    {
      id:30,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'AnyVue フィルム貼り付けビデオ AI 口頭修正',
      url: `${videoHttps}AnyVue_film_pasting_video_AI_oral_modification_${language}.mp4`,
    },
  ]

  //说明书资源
  let TOZO_pdf_https = 'https://s3-us.tozostore.com/tozo/pdfRenderer/web/'
  let Anybuds_pdf_https = 'https://s3-prod.anybuds.com/pdfRenderer/web/'
  let UserManual = 'UserManual'
  let QuickGuide = 'QuickGuide'

  let TOZO = 'TOZO'
  let Anybuds = 'Anybuds'

  // TOZO
  let preview_TOZO_UserManual_Url = `${TOZO_pdf_https}index.html?file=docs/${UserManual}/${TOZO}/`//预览用户指南
  let download_TOZO_UserManual_Url = `${TOZO_pdf_https}docs/${UserManual}/${TOZO}/` //下载用户指南

  let preview_TOZO_QuickGuide_Url = `${TOZO_pdf_https}index.html?file=docs/${QuickGuide}/${TOZO}/`//预览快速指引
  let download_TOZO_QuickGuide_Url = `${TOZO_pdf_https}docs/${QuickGuide}/${TOZO}/` //下载快速指引

  // Anybuds
  let preview_Anybuds_UserManual_Url = `${Anybuds_pdf_https}index.html?file=docs/${UserManual}/${Anybuds}/`//预览用户指南
  let download_Anybuds_UserManual_Url = `${Anybuds_pdf_https}docs/${UserManual}/${Anybuds}/` //下载用户指南

  let preview_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}index.html?file=docs/${QuickGuide}/${Anybuds}/`//预览快速指引
  let download_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}docs/${QuickGuide}/${Anybuds}/` //下载快速指引
  
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/docs/QuickGuide/TOZO/T6.pdf
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/index.html?file=docs/UserManual/TOZO/T6.pdf
  // https://s3-prod.anybuds.com/pdfRenderer/web/index.html?file=docs/UserManual/Anybuds/Clips.pdf
  let manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },

    {
      id:3,
      productId: 'TOZO_Color_Pods',
      productName: 'TOZO Color Pods',
      title:'TOZO Color Pods ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Color_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Color_Pods.pdf`,
    },
    // {
    //   id:4,
    //   productId: 'TOZO_Color_Pods',
    //   productName: 'TOZO Color Pods',
    //   title:'TOZO Color Pods クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    // },

    {
      id:5,
      productId: 'TOZO_HA1',
      productName: 'TOZO HA1',
      title:'TOZO HA1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HA1.pdf`,
    },
    // {
    //   id:6,
    //   productId: 'TOZO_HA1',
    //   productName: 'TOZO HA1',
    //   title:'TOZO HA1 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HA1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HA1.pdf`,
    // },

    // {
    //   id:7,
    //   productId: 'TOZO_HT1',
    //   productName: 'TOZO HT1',
    //   title:'TOZO HA1 ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}HT1.pdf`,
    // },
    {
      id:8,
      productId: 'TOZO_HT1',
      productName: 'TOZO HT1',
      title:'TOZO HT1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT1.pdf`,
    },
    

    {
      id:9,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_Open_X2_Pro',
      productName: 'TOZO Open X2 Pro',
      title:'TOZO Open X2 Pro ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
    },
    // {
    //   id:12,
    //   productId: 'TOZO_Open_X2_Pro',
    //   productName: 'TOZO Open X2 Pro',
    //   title:'TOZO Open X2 Pro クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    // },

    {
      id:11,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },


    {
      id:17,
      productId: 'TOZO_Open_EarRing',
      productName: 'TOZO Open EarRing',
      title:'TOZO Open EarRing ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing.pdf`,
    },
    // {
    //   id:18,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    // },

    // {
    //   id:19,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    // },
    // {
    //   id:20,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    // },

    {
      id:21,
      productId: 'TOZO_O2',
      productName: 'TOZO O2',
      title:'TOZO O2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}O2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}O2.pdf`,
    },
    // {
    //   id:22,
    //   productId: 'TOZO_O2',
    //   productName: 'TOZO O2',
    //   title:'TOZO O2 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}O2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}O2.pdf`,
    // },

    // {
    //   id:23,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}OpenWear.pdf`,
    // },
    // {
    //   id:24,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}OpenWear.pdf`,
    // },

    {
      id:25,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:26,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:27,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini.pdf`,
    },
    {
      id:28,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini.pdf`,
    },

    // {
    //   id:29,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    // },
    // {
    //   id:30,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    // },

    {
      id:31,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10.pdf`,
    },
    {
      id:32,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10.pdf`,
    },

    {
      id:33,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini.pdf`,
    },
    {
      id:34,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini.pdf`,
    },

    // {
    //   id:35,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    // },
    // {
    //   id:36,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    // },

    {
      id:37,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T9.pdf`,
    },
    {
      id:38,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T9.pdf`,
    },

    {
      id:39,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12.pdf`,
    },
    {
      id:40,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12.pdf`,
    },

    {
      id:41,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12_Pro.pdf`,
    },
    {
      id:42,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12_Pro.pdf`,
    },

    {
      id:43,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T20.pdf`,
    },
    {
      id:44,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T20.pdf`,
    },

    {
      id:45,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T21.pdf`,
    },
    {
      id:46,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T21.pdf`,
    },

    {
      id:47,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Dots.pdf`,
    },
    {
      id:49,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
    },

    {
      id:50,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Fits.pdf`,
    },
    {
      id:51,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
    },

    {
      id:52,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Buds.pdf`,
    },
    {
      id:53,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
    },

    {
      id:54,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC2.pdf`,
    },
    {
      id:55,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC2.pdf`,
    },

    {
      id:56,
      productId: 'TOZO_NC3',
      productName: 'TOZO NC3',
      title:'TOZO NC3 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3.pdf`,
    },
    {
      id:57,
      productId: 'TOZO_NC3',
      productName: 'TOZO NC3',
      title:'TOZO NC3 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3.pdf`,
    },

    // {
    //   id:58,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    // },
    // {
    //   id:59,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    // },

    {
      id:60,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC7.pdf`,
    },
    {
      id:61,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC7.pdf`,
    },

    {
      id:62,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (New T11124) ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9_new.pdf`,
    },
    // {
    //   id:63,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9_new.pdf`,
    // },

    {
      id:64,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (古い) ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9.pdf`,
    },
    {
      id:65,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (古い) クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9.pdf`,
    },

    //添加霍尔开关版本
    // {
    //   id:66,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New2) ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9-0xCD.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9-0xCD.pdf`,
    // },
    // {
    //   id:67,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New2) クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9-0xCD.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9-0xCD.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20',
      productName: 'TOZO NC20',
      title:'TOZO NC20 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20',
    //   productName: 'TOZO NC20',
    //   title:'TOZO NC20 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title:'TOZO NC20 Pro ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20_Pro.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20_Pro',
    //   productName: 'TOZO NC20 Pro',
    //   title:'TOZO NC20 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    // },

    {
      id:68,
      productId: 'TOZO_Crystal_Pods',
      productName: 'TOZO Crystal Pods',
      title:'TOZO Crystal Pods ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Pods.pdf`,
    },
    // {
    //   id:69,
    //   productId: 'TOZO_Crystal_Pods',
    //   productName: 'TOZO Crystal Pods',
    //   title:'TOZO Crystal Pods クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    // },

    {
      id:70,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 (New) ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1_new.pdf`,
    },
    // {
    //   id:71,
    //   productId: 'TOZO_A1_new',
    //   productName: 'TOZO A1_new',
    //   title:'TOZO A1_new クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1_new.pdf`,
    // },

    {
      id:72,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:73,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:74,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A2.pdf`,
    },
    {
      id:75,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A2.pdf`,
    },

    {
      id:76,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3.pdf`,
    },
    {
      id:77,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A3.pdf`,
    },
    
    //支持app
    {
      id:78,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 ユーザーマニュアル (サポートアプリ)',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3_APP.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3_APP.pdf`,
    },

    {
      id:79,
      productId: 'TOZO_E1',
      productName: 'TOZO E1',
      title:'TOZO E1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E1.pdf`,
    },

    // {
    //   id:80,
    //   productId: 'TOZO_E1',
    //   productName: 'TOZO E1',
    //   title:'TOZO E1 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E1.pdf`,
    // },

    {
      id:81,
      productId: 'TOZO_E2',
      productName: 'TOZO E2',
      title:'TOZO E2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E2.pdf`,
    },
    // {
    //   id:82,
    //   productId: 'TOZO_E2',
    //   productName: 'TOZO E2',
    //   title:'TOZO E2 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E2.pdf`,
    // },
    

    {
      id:83,
      productId: 'TOZO_Watch1',
      productName: 'TOZO Watch1',
      title:'TOZO Watch1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Watch1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Watch1.pdf`,
    },
    // {
    //   id:84,
    //   productId: 'TOZO_Watch1',
    //   productName: 'TOZO Watch1',
    //   title:'TOZO Watch1 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Watch1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Watch1.pdf`,
    // },

    {
      id:85,
      productId: 'TOZO_S2',
      productName: 'TOZO S2',
      title:'TOZO S2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S2.pdf`,
    },
    // {
    //   id:86,
    //   productId: 'TOZO_S2',
    //   productName: 'TOZO S2',
    //   title:'TOZO S2 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S2.pdf`,
    // },

    // {
    //   id:87,
    //   productId: 'TOZO_S3',
    //   productName: 'TOZO S3',
    //   title:'TOZO S3 ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S3.pdf`,
    // },
    // // {
    // //   id:88,
    // //   productId: 'TOZO_S3',
    // //   productName: 'TOZO S3',
    // //   title:'TOZO S3 クイックガイド',
    // //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S3.pdf`,
    // //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S3.pdf`,
    // // },

    // {
    //   id:89,
    //   productId: 'TOZO_S4',
    //   productName: 'TOZO S4',
    //   title:'TOZO S4 ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S4.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S4.pdf`,
    // },
    // // {
    // //   id:90,
    // //   productId: 'TOZO_S4',
    // //   productName: 'TOZO S4',
    // //   title:'TOZO S4 クイックガイド',
    // //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S4.pdf`,
    // //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S4.pdf`,
    // // },

    {
      id:91,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    // {
    //   id:92,
    //   productId: 'TOZO_S5',
    //   productName: 'TOZO S5',
    //   title:'TOZO S5 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    // },

    // {
    //   id:93,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S6.pdf`,
    // },
    // {
    //   id:94,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S6.pdf`,
    // },

    {
      id:95,
      productId: 'TOZO_S7',
      productName: 'TOZO S7',
      title:'TOZO S7 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S7.pdf`,
    },
    // {
    //   id:96,
    //   productId: 'TOZO_S7',
    //   productName: 'TOZO S7',
    //   title:'TOZO S7 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S7.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S7.pdf`,
    // },

    {
      id:97,
      productId: 'TOZO_S8',
      productName: 'TOZO S8',
      title:'TOZO S8 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S8.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S8.pdf`,
    },
    // {
    //   id:98,
    //   productId: 'TOZO_S8',
    //   productName: 'TOZO S8',
    //   title:'TOZO S8 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S8.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S8.pdf`,
    // },

    {
      id:99,
      productId: 'TOZO_AcuFit_Lite',
      productName: 'TOZO AcuFit Lite',
      title:'TOZO AcuFit Lite ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
    },
    // {
    //   id:100,
    //   productId: 'TOZO_AcuFit_Lite',
    //   productName: 'TOZO AcuFit Lite',
    //   title:'TOZO AcuFit Lite クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    // },

    {
      id:101,
      productId: 'TOZO_AcuFit_One',
      productName: 'TOZO AcuFit One',
      title:'TOZO AcuFit One ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_One.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_One.pdf`,
    },
    // {
    //   id:102,
    //   productId: 'TOZO_AcuFit_One',
    //   productName: 'TOZO AcuFit One',
    //   title:'TOZO AcuFit One クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_One.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_One.pdf`,
    // },

    {
      id:102,
      productId: 'TOZO_AcuFit_GT',
      productName: 'TOZO AcuFit GT',
      title:'TOZO AcuFit GT ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_GT.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_GT.pdf`,
    },
    // {
    //   id:103,
    //   productId: 'TOZO_AcuFit_GT',
    //   productName: 'TOZO AcuFit GT',
    //   title:'TOZO AcuFit GT クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    // },
    

    {
      id:104,
      productId: 'TOZO_AcuFit_Solo',
      productName: 'TOZO AcuFit Solo',
      title:'TOZO AcuFit Solo ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
    },
    // {
    //   id:105,
    //   productId: 'TOZO_AcuFit_Solo',
    //   productName: 'TOZO AcuFit_Solo',
    //   title:'TOZO AcuFit Solo クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    // },

    {
      id:106,
      productId: 'TOZO_AcuFit_Evo',
      productName: 'TOZO AcuFit Evo',
      title:'TOZO AcuFit Evo ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
    },
    // {
    //   id:107,
    //   productId: 'TOZO_AcuFit_Evo',
    //   productName: 'TOZO AcuFit Evo',
    //   title:'TOZO AcuFit Evo クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    // },

    {
      id:108,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PA1.pdf`,
    },
    {
      id:109,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PA1.pdf`,
    },

    {
      id:110,
      productId: 'TOZO_PA2',
      productName: 'TOZO PA2',
      title:'TOZO PA2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PA2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PA2.pdf`,
    },
    // {
    //   id:111,
    //   productId: 'TOZO_PA2',
    //   productName: 'TOZO PA2',
    //   title:'TOZO PA2 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PA2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PA2.pdf`,
    // },

    {
      id:112,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PE1.pdf`,
    },
    {
      id:113,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PE1.pdf`,
    },

    {
      id:114,
      productId: 'TOZO_W1',
      productName: 'TOZO W1',
      title:'TOZO W1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W1.pdf`,
    },
    // {
    //   id:115,
    //   productId: 'TOZO_W1',
    //   productName: 'TOZO W1',
    //   title:'TOZO W1 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W1.pdf`,
    // },

    {
      id:116,
      productId: 'TOZO_W6',
      productName: 'TOZO W6',
      title:'TOZO W6 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W6.pdf`,
    },
    // {
    //   id:117,
    //   productId: 'TOZO_W6',
    //   productName: 'TOZO W6',
    //   title:'TOZO W6 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W6.pdf`,
    // },

    {
      id:118,
      productId: 'TOZO_W10',
      productName: 'TOZO W10',
      title:'TOZO W10 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W10.pdf`,
    },
    // {
    //   id:119,
    //   productId: 'TOZO_W10',
    //   productName: 'TOZO W10',
    //   title:'TOZO W10 クイックガイド',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W10.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W10.pdf`,
    // },


    // Anybuds
    // {
    //   id:120,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Clips.pdf`,
    // },
    // {
    //   id:121,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips クイックガイド',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Clips.pdf`,
    // },

    // {
    //   id:122,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Dots.pdf`,
    // },
    // {
    //   id:123,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots クイックガイド',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Dots.pdf`,
    // },

    // // {
    // //   id:124,
    // //   productId: 'Anybuds_Fits',
    // //   productName: 'Anybuds Fits',
    // //   title:'Anybuds Fits ユーザーマニュアル',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Fits.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Fits.pdf`,
    // // },
    // {
    //   id:125,
    //   productId: 'Anybuds_Fits',
    //   productName: 'Anybuds Fits',
    //   title:'Anybuds Fits クイックガイド',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Fits.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Fits.pdf`,
    // },

    // // {
    // //   id:126,
    // //   productId: 'Anybuds_Pro',
    // //   productName: 'Anybuds Pro',
    // //   title:'Anybuds Pro ユーザーマニュアル',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Pro.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Pro.pdf`,
    // // },
    // {
    //   id:127,
    //   productId: 'Anybuds_Pro',
    //   productName: 'Anybuds Pro',
    //   title:'Anybuds Pro クイックガイド',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Pro.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Pro.pdf`,
    // },

    // {
    //   id:128,
    //   productId: 'Anybuds_Vivid',
    //   productName: 'Anybuds Vivid',
    //   title:'Anybuds Vivid ユーザーマニュアル',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Vivid.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Vivid.pdf`,
    // },
    // // {
    // //   id:129,
    // //   productId: 'Anybuds_Vivid',
    // //   productName: 'Anybuds Vivid',
    // //   title:'Anybuds Vivid クイックガイド',
    // //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // // },

  ]
  
  //热门FAQ资源
  let hot_faqList = [
    {
      know_id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'イヤホンが充電されないのはなぜですか?',
      description: `
      金属コネクタが汚れていないか確認し、乾いた布、ペーパークリップ、またはペーパータオルで軽く拭いてください。
      (汗や湿気も切断の原因になることがあります) <br/>
      2. 最初はイヤホンを入れずにバッテリーケースを完全に充電してください。 <br/>
      · 左と右のイヤホンを入れ替えて充電してみてください。 <br/>
      · 左のイヤホンをケースの右側に入れ、右のイヤホンもケースの左側に入れます。 <br/>
      · 上記の手順を実行した後、バッテリーケースの問題かどうかを確認します。 <br/>
      3. リセットすると、発生した多くの問題を解決できます。 <br/>
      `
    },
    {
      know_id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'イヤホンで音量を調整するには?',
      description: `
      音楽を再生中に、L または R イヤホンを長押しして音量を調整します。<br/>
      R イヤホンの音量 + <br/>
      L イヤホンの音量 - <br/>
      テレビやコンピューターに接続されている場合、音量調整は利用できません。<br/>
      `
    },
    {
      know_id:3,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'コンピューターにイヤホンを接続するにはドライバーまたはトランスミッターが必要だと表示されたら、どうすればいいですか?',
      description: `
      以下にいくつかの方法を示します。<br/>
      ·接続するには Bluetooth レシーバーをダウンロードします (コンピューターの設定で) <br/>
      ·コンピューターの Bluetooth バージョンが Bluetooth 5.0 をサポートしているかどうかを確認してください <br/>
      `
    },
    {
      know_id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: 'TOZO HT2 ヘッドフォンの主な機能は何ですか?',
      description: `
      TOZO HT2 は、アダプティブ ハイブリッド アクティブ ノイズ キャンセリング、40mm ダイナミック ドライバー ユニット、Hi-Res オーディオ認証、3 MIC ENC 通話ノイズ キャンセリングを備えています。
      `
    },
    {
      know_id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'TOZO Open Buds のユニークな点は何ですか?',
      description: `
      TOZO Open Buds は、カスタマイズ可能な快適性を実現する革新的な二軸回転設計と、周囲の状況を常に把握できるオープンイヤー設計を特徴としています。
      `
    },
    {
      know_id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'TOZO Open Buds の音質はどうですか?',
      description: `
      14.2mm の大型ダイナミック ドライバー ユニットが、パワフルな低音を備えたクリアで高品質なサウンドを実現します。
      `
    },
    {
      know_id:7,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'TOZO Open Buds は快適に装着できますか?',
      description: `
      はい、2 軸回転設計により多角度調整が可能になり、長時間使用しても最高の快適さを実現します。
      `
    },
    {
      know_id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'TOZO OpenReal イヤホンの主な特徴は何ですか?',
      description: `
      TOZO OpenReal は、オープンイヤー デザイン、空気伝導技術、Bluetooth 5.3、通話ノイズキャンセル用のデュアルマイク ENC、クリアでパワフルなサウンドを実現する 16.2mm ダイナミック ドライバーを備えています。
      `
    },
    {
      know_id:9,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'TOZO OpenReal イヤホンの音質はいかがですか?',
      description: `
      16.2mm ダイナミック ドライバーは、クリアな高音とパワフルな低音を備えた美しいサウンドを提供します。
      `
    },
    {
      know_id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'TOZO OpenEgo ヘッドフォンの主な特徴は何ですか?',
      description: `
      TOZO OpenEgo は、快適なオープンイヤー デザイン、クリアな音楽を実現する空気伝導技術、安定した接続を実現する Bluetooth 5.3、通話ノイズキャンセルを実現するデュアルマイク DNS、高品質のサウンドを実現する 16.2mm ダイナミック ドライバーを備えています。
      `
    },
    {
      know_id:11,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'TOZO OpenEgo ヘッドフォンにはどのようなノイズキャンセル機能がありますか?',
      description: `
      デュアルマイク DNS (デジタル ノイズ抑制) テクノロジーを搭載しており、バックグラウンド ノイズを最小限に抑えてクリアな通話を実現します。
      `
    },
    {
      know_id:12,
      productId: 'TOZO_PA2',
      productName: 'TOZO PA2',
      browse: '',
      give: '',
      title: 'TOZO PA2 Bluetooth スピーカーの主な機能は何ですか?',
      description: `
      TOZO PA2 は、臨場感あふれるステレオ サウンド、3 つの EQ モード、25 時間の再生時間、IPX8 防水、Bluetooth 通話を提供します。
      `
    },
    {
      know_id:13,
      productId: 'TOZO_S1',
      productName: 'TOZO S1',
      browse: '',
      give: '',
      title: 'この時計は防水ですか?',
      description: `
      はい、この時計は防水で日常使用に適していますが、長時間水に浸すことは避けることをお勧めします。
      `
    },
  ]

  //热门故障资源
  let hot_TrobuleshootingList = [
    {
      know_id:1,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: 'TOZO HT2 をリセットするには?',
      description: `
      工場出荷時の設定に戻す ヘッドセットの電源がオンのとき。プラスキーとマイナスキーを同時に 8 秒間押し続けると、工場出荷時の設定に戻ります。
      `
    },
    
    {
      know_id:2,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: 'TOZO OpenReal をリセットするには?',
      description: `
      イヤホンを充電ケースに入れたら、充電ケースボタンを 8 秒間押し続けると、Bluetooth ペアリング記録が消去され、工場出荷時の設定に戻ります。
      `
    },
    
    {
      know_id:3,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: 'TOZO Open Buds をリセットするには?',
      description: `
      イヤホン (またはイヤホンのいずれか) がペアリングまたは接続されない / 音が途切れる / イヤホンが Bluetooth 検索で見つからない <br/>

      イヤホンの 1 つが機能しない、またはペアリングに失敗した場合は、リセットしてください: <br/>
      タッチ領域と「-」ボタンを同時に 5 秒間押し続けます。インジケータ ライトがオフになり、赤と白に点滅します。これはリセットが成功したことを示します。
      `
    },
    
    {
      know_id:4,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: 'TOZO OpenEgo をリセットするには?',
      description: `
      7.0 リセット <br/>
      誤って片方のイヤホンしか機能しない場合、または互いにペアリングできない場合は、リセットしてください: <br/>
      イヤホンの電源がオンでペアリング モードになっているときに、どちらかのイヤホンをすばやく 6 回タップします。 <br/>
      白いインジケータ ライトが 6 回すばやく点滅した後、赤いライトが 1 秒間点灯したままになり、イヤホンの電源がオフになっていることを示します。電源をオフにすると、イヤホンの電源が自動的にオンになり、工場出荷時設定へのリセットが成功したことを示します。 <br/>
      注: デバイスで接続に失敗した場合は、[TOZO OpenEgo] のすべての履歴レコードを削除して、ペアリング プロセスを再度試してください。
      `
    },
    
    {
      know_id:5,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: 'TOZO Golden X1 をリセットするには?',
      description: `
      1. イヤホンを充電ケースに入れます。 <br/>
      2. ケース ボタンを 15 秒間押したままにし、蓋を開けたまま 10 秒間待ってからイヤホンを取り外します。 <br/>
      注意: デバイスに [接続失敗] が表示される場合は、[TOZO Golden X1] の履歴をすべて削除し、ペアリング プロセスを再度試してください。
      `
    },
    
    {
      know_id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      browse: '',
      give: '',
      title: 'TOZO T6(クラシックエディション)をリセットするには?',
      description: `
      (1) リセットする前に、Bluetooth 上のすべての TOZO を削除/忘れ、Bluetooth 機能もオフにします。<br/>
      (2) イヤホンのパネルを 5 秒間押して、デバイスの電源をオフにします (赤いライトが点滅します)。<br/>
      (3) 数秒後、両方のイヤホンを 5 秒間タッチしたままにすると、赤/青のライトが同時に点滅します。次に、両方のイヤホンを 3 回すばやくタッチします。紫色のライトが点滅したら、リセットが完了します。<br/>
      (4) 最後に、BT をオンにして再接続します。
      `
    },
    
    {
      know_id:7,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      browse: '',
      give: '',
      title: 'TOZO T6(クラシックエディション)をリセットするには?',
      description: `
      (1) リセットする前に、Bluetooth 上のすべての TOZO を削除/忘れ、Bluetooth 機能もオフにします。<br/>
      (2) イヤホンのパネルを 5 秒間押して、デバイスの電源をオフにします (赤いライトが点滅します)。 <br/>
      (3) 数秒後、両方のイヤホンを 5 秒間タッチしたままにすると、赤/青のライトが同時に点滅します。次に、両方のイヤホンを 3 回すばやくタッチします。紫色のライトが点滅したら、リセットが完了します。<br/>
      (4) 最後に、BT をオンにして再接続します。
      `
    },
    
    {
      know_id:8,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      browse: '',
      give: '',
      title: 'TOZO T9 をリセットするには?',
      description: `
      1. デバイス上の [TOZO-T9] Bluetooth レコードをすべて削除し、Bluetooth 機能をオフにします。<br/>
      2. 両方のイヤホンを充電ケースから取り出し、両方のイヤホンを 5 秒間押したままにすると、白いライトが点滅し、2 つのイヤホンがオフになります。<br/>
      3. 数秒後、両方のイヤホンをもう一度 5 秒間押したままにすると、白いライトがしばらく表示されます。白いライトが消えたら、イヤホンを 2 回すばやくタップします。片方のイヤホンだけが頻繁に点滅している場合は、リセットが完了しています。 <br/>
      4. イヤホンを充電ケースに戻し、再度取り出してデバイスに再接続します。<br/>
      注: デバイスに [接続に失敗しました] と表示された場合は、ペアリングする前にすべてのデバイスから [TOZO-T9] Bluetooth レコードをすべて削除してください。<br/>
      `
    },
    
    {
      know_id:9,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      browse: '',
      give: '',
      title: 'TOZO T10 (クラシックエディション) をリセットするには?',
      description: `
      (1) リセットする前に、Bluetooth 上のすべての TOZO を削除/忘れ、Bluetooth 機能もオフにします。<br/>
      (2) イヤホンのパネルを 5 秒間押して、デバイスの電源をオフにします (赤いライトが点滅します)。<br/>
      (3) 数秒後、両方のイヤホンを 5 秒間タッチしたままにすると、赤/青のライトが同時に点滅します。次に、両方のイヤホンをすばやく 2 回タッチします。紫色のライトが点滅したら、リセットが完了します。<br/>
      (4) 最後に、BT をオンにして再接続します。<br/>
      `
    },
    
    {
      know_id:10,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 mini',
      browse: '',
      give: '',
      title: 'TOZO T10 (Ergonomic with APP Edition(2024)) をリセットするには??',
      description: `
      1. 携帯電話上の [TOZO T10] Bluetooth レコードをすべて削除し、Bluetooth をオフにします。<br/>
      2. 充電ケースから 2 つのイヤホンを取り出し、両方のイヤホンをすばやく 2 回クリックします。 <br/>
      3. 青色のライトが高速で点滅し、その後イヤホンの 1 つが赤色と青色のライトが交互に点滅すると、リセットが完了します。<br/>
      注: デバイスで接続に失敗した場合は、[TOZO T10] の履歴レコードをすべて削除して、ペアリング プロセスを再度試してください。<br/>
      `
    },
    
    {
      know_id:11,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      browse: '',
      give: '',
      title: 'TOZO T12 をリセットする方法は?',
      description: `
      (1) リセットする前に、Bluetooth 上のすべての TOZO を削除/忘れ、Bluetooth 機能もオフにします。<br/>
      (2) イヤホンのパネルを 5 秒間押して、デバイスの電源をオフにします (赤色のライトが点滅します)。<br/>
      (3) 数秒後、両方のイヤホンを 5 秒間タッチしたままにすると、赤色と青色のライトが同時に点滅します。次に、両方のイヤホンを 3 回すばやくタッチします。紫色のライトが点滅したら、リセットが完了します。<br/>
      (4) 最後に、BT をオンにして再接続します。 <br/>
      イヤホンを充電ケースから取り出し、[TOZO T12] を接続して再起動してください。<br/>
      `
    },
    
    {
      know_id:12,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      browse: '',
      give: '',
      title: 'TOZO T12 Proをリセットするには？',
      description: `
      1. まず、お使いの携帯電話にあるこれらの[TOZO-T12 Pro] Bluetoothレコードの両方を削除/忘れてから、Bluetoothをオフにしてください。<br/>
      2. 以下の方法でそれぞれを個別にリセットします。一緒にリセットしないでください。<br/>
      (1)イヤホンのタッチボタンを約5秒間押し続け、赤いライトが1秒間点灯してから消灯します。<br/>
      (2)数秒後、イヤホンのタッチボタンを5秒間押し続けます。赤/青のライトが同時に点滅したら、すばやく3回タップします。<br/>
      (3)紫色のライトが1秒間点滅したら、1つのイヤホンのリセットプロセスが完了します。次に、この方法をもう一度実行して、別のイヤホンをリセットします。<br/>
      3. リセット後、充電ケースに戻して蓋を閉じます。次に、ケースから取り出し、30秒間そのままにしておきます。<br/>
      4. 最後に、携帯電話のBluetoothをオンにして、[TOZO T12 Pro]を再度接続します。
      `
    },
    
    {
      know_id:13,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      browse: '',
      give: '',
      title: 'TOZO T20をリセットするには？',
      description: `
      イヤホンが充電ボックス内にあるときに、LとRの感知エリアを6秒間長押ししてリセットします。
      `
    },
    
    {
      know_id:14,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      browse: '',
      give: '',
      title: 'TOZO T21をリセットするには？',
      description: `
      1. デバイスのBluetoothをオフにします。両方のイヤホンを充電ケースに入れ、数秒間IDを閉じます。<br/>
      2. 充電ケースから取り出し、イヤホンの白いインジケータライトがゆっくり点滅します。次に、両側のタッチパネルを同時にダブルクリックすると、インジケータライトが約3秒間すばやく点滅し、その後ゆっくり点滅に変わり、リセットが完了したことを示します。次に、デバイスのBluetoothをオンにして、イヤホンを再度接続します。 <br/>
      3. 障害が続く場合は、前の手順を再度実行してください。<br/>
      TOZO NC2 をリセットするには?
      誤って片方のイヤホンしか機能しない場合、または相互にペアリングできない場合は、リセットしてください: <br/>
      イヤホンを充電ケースに入れ、蓋を開け、ケースボタンを 15 秒間押し続けます。<br/>
      注意: デバイスに [接続失敗] がある場合は、[TOZO-NC2] のすべての履歴記録を削除して、ペアリング プロセスを再度試してください。<br/>
      リセット後: <br/>
      充電ボックスを開き、イヤホンを充電ボックスに入れたまま、充電ボックスのボタンを 3 秒間押して、イヤホンを強制的にペアリング状態にします。この操作では、以前の Bluetooth ペアリング記録はクリアされないことに注意してください。<br/>
      `
    },
    
    {
      know_id:15,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      browse: '',
      give: '',
      title: 'TOZO NC2 をリセットするには?',
      description: `
      誤って片方のイヤホンしか機能しない場合、または相互にペアリングできない場合は、リセットしてください: <br/>
      イヤホンを充電ケースに入れ、蓋を開け、ケースボタンを 15 秒間押し続けます。 <br/>
      注: デバイスに [接続失敗] が表示される場合は、[TOZO-NC2] のすべての履歴レコードを削除して、ペアリング プロセスを再試行してください。 <br/>
      リセット後: <br/>
      充電ボックスを開き、イヤホンを充電ボックスに入れたまま、充電ボックスのボタンを 3 秒間押して、イヤホンを強制的にペアリング状態にします。この操作では、以前の Bluetooth ペアリング レコードはクリアされないことに注意してください。 <br/>
      `
    },
    
    {
      know_id:16,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      browse: '',
      give: '',
      title: 'TOZO NC7 をリセットするには?',
      description: `
      1. 携帯電話の [TOZO-NC7] Bluetooth レコードをすべて削除し、Bluetooth 機能をオフにします。 <br/>
      2. 両方のイヤホンを充電ケースから取り出し、両方のイヤホンのタッチボタンを5秒間押したままにすると、赤いライトが1秒間点灯して消えます。<br/>
      3. 数秒後、両方のイヤホンのタッチボタンを5秒間押したままにします。青いライトが点灯と消灯を繰り返すと、ボタンをすばやく2回タップすると、2つのイヤホンの青いライトが頻繁に点滅し、最後に紫色のライトが約1秒間点灯して、リセットが完了したことを示します。
      注：デバイスに[接続に失敗しました]と表示された場合は、ペアリングする前に、すべてのデバイスで[TOZO-NC7] Bluetoothレコードをすべて削除してください。<br/>
      `
    },
    
    {
      know_id:17,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      browse: '',
      give: '',
      title: 'TOZO NC9をリセットする方法は？',
      description: `
      1. 携帯電話のTOZO-NC9 Bluetoothレコードをすべて削除してから、Bluetoothをオフにします。<br/>
      2. 両方のイヤホンのタッチボタンを約5秒間押したままにすると、赤いライトが1秒間点灯して消えます。 <br/>
      3. 数秒後、両方のイヤホンのタッチボタンを5秒間押し続けます。イヤホンの青いライトが点灯したり消えたりしたら、両方のタッチボタンを2～3回素早くクリックします。<br/>
      4. 赤いライトが1秒間点滅したら、リセットプロセスが完了します。その後、充電ケースに戻し、もう一度取り出してデバイスに接続します。<br/>
      注：デバイスに[接続失敗]がある場合は、[TOZO-NC9]の履歴をすべて削除し、ペアリングプロセスを再度試してください。<br/>
      `
    },
    
    {
      know_id:18,
      productId: 'TOZO_NC9_Plus',
      productName: 'TOZO NC9 Plus',
      browse: '',
      give: '',
      title: 'TOZO NC9 Plus をリセットするには?',
      description: `
      1. 携帯電話の TOZO-NC9 Plus Bluetooth 記録をすべて削除し、Bluetooth をオフにします。<br/>
      2. 両方のイヤホンのタッチボタンを約 5 秒間押し続けます。赤いライトが 1 秒間点灯してから消えます。<br/>
      3. 数秒後、2 つのイヤホンのタッチボタンを 5 秒間押し続けます。イヤホンの青いライトが点灯して消えたら、両方のタッチボタンをすばやく 2 回または 3 回クリックします。<br/>
      4. 赤いライトが 1 秒間点滅したら、リセット プロセスが完了します。その後、充電ケースに戻し、もう一度取り出してデバイスに接続します。<br/>
      注: デバイスに [接続失敗] がある場合は、[TOZO-NC9 Plus] のすべての履歴記録を削除し、ペアリング プロセスを再試行してください。<br/>
      `
    },
    
    {
      know_id:19,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      browse: '',
      give: '',
      title: 'TOZO A1 をリセットするには?',
      description: `
      1. デバイス上の [TOZO-A1] の記録を削除/忘れてから、Bluetooth 機能をオフにします。<br/>
      2. 両方のイヤホンを充電ケースから取り出し、両方のタッチボタンをすばやく 5 回タップします。赤いライトが 1 秒間点滅したらリセットが完了します。<br/>
      3. 最初にイヤホンをケースに戻し、蓋を閉じます。次に、もう一度取り出してデバイスに再接続します。<br/>
      注: デバイスに [接続に失敗しました] と表示された場合は、ペアリングする前に、すべてのデバイス上の [TOZO-A1] Bluetooth 記録をすべて削除してください。<br/>
      `
    },
    
    {
      know_id:20,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      browse: '',
      give: '',
      title: 'TOZO A2 をリセットする方法は?',
      description: `
      1. デバイス上の [TOZO-A2] Bluetooth 記録をすべて削除してから、Bluetooth 機能をオフにします。 <br/>
      2. 充電ケースから 2 つのイヤホンを取り出して装着し、両方のイヤホンを約 5 秒間押したままにし、「電源オフ」と聞こえたら指を離します。<br/>
      3. 両方のイヤホンをもう一度約 8 秒間押したままにし、「PTP ペアリング」と聞こえたら指を離すと、リセットが完了します。<br/>
      4. イヤホンをケースに入れて再び取り出すと、2 つのイヤホンが交互に赤と青に点滅します。Bluetooth をオンにしてイヤホンを接続します。<br/>
      `
    },
    
    {
      know_id:21,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      browse: '',
      give: '',
      title: 'TOZO A3 をリセットするには?',
      description: `
      両方のイヤホンを充電ケースに入れ、デバイスで [TOZO- A3] を忘れる/ペアリング解除します。<br/>
      1. 充電ケースを開き、イヤホンを入れたままにします。<br/>
      2. 充電ケースのボタンを 8 秒間押し続けます。ボックスのインジケータ ライトが 5 回点滅し、イヤホンの白いライトが高速で点滅します。<br/>
      3. イヤホンを充電ケースから取り出し、デバイスに再度接続します。<br/>
      `
    },
    
    {
      know_id:22,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      browse: '',
      give: '',
      title: 'TOZO Crystal Buds をリセットするには?',
      description: `
      (1) 携帯電話の Bluetooth をオフにし、[TOZO Crystal Buds] の Bluetooth レコードをすべて削除/忘れます。<br/>
      (2) イヤホンを充電ケースから取り出し、タッチ パネルを 5 秒間押してイヤホンをオフにします。<br/>
      (3) 両方のイヤホンを同時に 8 秒間押し続け、白いライトが高速で点滅したら離します。リセットが完了しました。<br/>
      `
    },
    
    {
      know_id:23,
      productId: 'TOZO_G1',
      productName: 'TOZO G1',
      browse: '',
      give: '',
      title: 'TOZO G1 をリセットするには?',
      description: `
      工場出荷時の設定に戻すには、以下の手順に従ってください: <br/>
      1. 携帯電話の [TOZO-G1] レコードをすべて削除し、Bluetooth 機能もオフにします。<br/>
      2. 充電ケースからイヤホンを取り出し、両方のイヤホンの MFB タッチボタンをすばやく 5 回タップすると、イヤホンがオフになります。<br/>
      3. イヤホンを充電ケースに戻し、蓋を閉じます。次に、イヤホンをもう一度取り出します。片方のイヤホンの呼吸ライトが点灯し、もう一方のイヤホンが点滅すると、リセット プロセスが完了します。<br/>
      `
    },
    
    {
      know_id:24,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      browse: '',
      give: '',
      title: 'TOZO H10 をリセットするには?',
      description: `
      ヘッドセットの電源がオンのときに工場出荷時の設定に復元します。プラス キーとマイナス キーを同時に 8 秒間押し続けると、工場出荷時の設定に復元されます
      `
    },
    
    {
      know_id:25,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      browse: '',
      give: '',
      title: '手首を上げても画面が点灯しません。',
      description: `
      ウォッチ設定の確認: ウォッチで Raise-to-Wake 機能が有効になっていることを確認します。<br/>
      アプリ設定の確認: Raise-to-Wake 機能がコンパニオン アプリでも有効になっていることを確認します。<br/>
      アクティブ時間設定の確認: 現在の時刻がアプリで設定されているアクティブ画面オン期間内であることを確認します。デフォルトでは、画面オン時間は午前 8 時から午後 8 時までに設定されています。ユーザーがこの時間範囲を調整する必要がある場合は、アプリ内で調整できます。<br/>
      `
    },
    
    {
      know_id:26,
      productId: 'Watches',
      productName: 'Watches',
      browse: '',
      give: '',
      title: 'スマートウォッチはメッセージを受信できますが、通話の発信や受信はできません',
      description: `
      アプリ接続の確認: <br/> <br/>

      コンパニオン アプリがスマートウォッチに正しく接続されていることを確認します。 <br/>
      システムの Bluetooth 設定を確認します: <br/> <br/>

      デバイスの Bluetooth 設定に移動し、デバイスの詳細を入力します。画面が「図 2」のようになっている場合は、通話関連の Bluetooth 接続が確立されていないことを示します。<br/>
      「このデバイスを忘れる」をタップして、Bluetooth リストからデバイスを削除します。<br/>
      アプリ経由で Bluetooth を再接続します: <br/> <br/>

      コンパニオン アプリに戻ります。Bluetooth を再接続するためのプロンプトが表示されます。<br/>
      「セットアップ」ボタンをタップすると、自動的にシステムの Bluetooth 設定ページに移動します。接続を確認します。接続を確認します: <br/> <br/>

      Bluetooth 設定でデバイスの詳細を再入力します。画面が「図 4」のようになっている場合は、通話関連の Bluetooth 接続が成功しています。<br/>
      接続が確立されていない場合は、「図 4」のような画面が表示されるまで上記の手順を繰り返します。
      `
    },
  ]

  //热门说明书资源
  let hot_manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },

    {
      id:3,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:7,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:9,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 ユーザーマニュアル',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 クイックガイド',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    },
  ]

  //热门视频资源
  let hot_VideoTutoralList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    
    {
      id:3,
      productId: 'TOZO_OpenBuds',
      productName: 'TOZO OpenBuds',
      title: 'TOZO Open Buds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:4,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:7,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
  ]

  //自定义的本地数据分页
  function customPaginateData(data, page, perPage) {
    // 确保页数和每页条数是有效的
    page = Math.max(1, page);
    perPage = Math.max(1, perPage);
  
    // 计算总记录数
    const total = data.length;
  
    // 计算总页数
    const lastPage = Math.ceil(total / perPage);
  
    // 计算当前页的开始和结束索引
    const start = (page - 1) * perPage;
    const end = Math.min(start + perPage, total);
  
    // 获取当前页的数据
    const currentPageData = data.slice(start, end);
  
    return {
      current_page: page,
      last_page: lastPage,
      per_page: perPage,
      to: end,
      total: total,
      data: currentPageData
    };
  }